import { memo } from "react";
import { bool, func, node, string } from "prop-types";
import { Checkbox } from "@components";
import { Grid, IconButton } from "@material-ui/core";
import { Trash } from "@assets";

export const SettingEntry = memo(({
  name,
  label,
  visible,
  disabled,
  onRemove,
  setVisibility,
  children,
}) => (
  <Grid item xs={ 12 }>
    <Checkbox
      name={ name }
      aria-label={ name }
      checked={ visible }
      onChange={ () => setVisibility(!visible) }
      className="mr-1"
      labelClassName="m-0"
      label={ label }
      disabled={disabled}
    />
    {
      Boolean(onRemove) &&
      <IconButton
        color="secondary"
        className="ml-3"
        onClick={onRemove}
      >
        <Trash className="color-error text-md" />
      </IconButton>
    }
    { children }
  </Grid>
))

SettingEntry.propTypes = {
  name: string.isRequired,
  label: string.isRequired,
  visible: bool.isRequired,
  setVisibility: func.isRequired,
  onRemove: func,
  disabled: bool,
  children: node,
}